"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationSource = void 0;
exports.ValidationSource = {
    RequiredConstraint: "required-constraint",
    UniqueConstraint: "unique-constraint",
    CustomLogic: "custom-logic",
    Unlinked: "unlinked",
    InvalidOption: "invalid-option",
    IsArtifact: "is-artifact",
};
